<script setup lang="ts">
import AppFooter from "@components/AppFooter.vue";
import AppHeader from "@components/AppHeader.vue";
import { useAuthStore } from "@features/authentication/stores";
import { useCartStore, useOrderStore, useProductStore } from "@features/shopping/stores";
import { Toaster } from "@ui/toast";
import { useHead } from "@unhead/vue";
import { useScriptTag } from "@vueuse/core";
import { onMounted } from "vue";
import { RouterView } from "vue-router";

const authStore = useAuthStore();
const productStore = useProductStore();
const cartStore = useCartStore();
const orderStore = useOrderStore();

// SEO
useHead({
  title: "Home",
  titleTemplate: "%s – Molly Factory",
});

// Google reCAPTCHA
useScriptTag("https://www.google.com/recaptcha/api.js");

onMounted(async () => {
  if (!authStore.currentUser) {
    await authStore.initializeAuth();
  }

  await productStore.initializeProducts();
  await cartStore.initializeCart();
  await orderStore.initializeOrders(cartStore.getMemberId);
});
</script>

<template>
  <AppHeader />
  <RouterView />
  <AppFooter />
  <Toaster />
</template>
